import React, {useEffect, useState} from 'react';
import {PieChart, Pie, Cell, Legend, Tooltip, Sector,} from 'recharts';


const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
        <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
            {`${(percent * 100).toFixed(0)}%`}
        </text>
    );
};
const renderActiveShape = (props) => {
    const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill } = props;

    return (
        <g>
            <Sector
                cx={cx}
                cy={cy}
                innerRadius={innerRadius}
                outerRadius={outerRadius}
                startAngle={startAngle}
                endAngle={endAngle}
                fill={fill}
            />
            <Sector
                cx={cx}
                cy={cy}
                startAngle={startAngle}
                endAngle={endAngle}
                innerRadius={outerRadius + 6}
                outerRadius={outerRadius + 10}
                fill={fill}
            />
        </g>
    );
};
const YesNoPieChart = (props) => {


    const [dataArray, setDataArray] = useState([])
    const COLORS = ['#0088FE', '#F30000'];
    const [activeIndex, setActiveIndex] = useState(0);

    const onPieEnter = (_, index) => {
        setActiveIndex(index);
    };

    useEffect(() => {
        const data = [
            { name: 'Yes', value: props.answers?.filter(x => x === "Yes")?.length },
            { name: 'No', value: props.answers?.filter(x => x === "No")?.length },
        ];

        console.log(data);
        setDataArray([...data]);
    }, [props.answers])

    return (
        <PieChart width={window.innerWidth-300} height={window.innerHeight-500}>
            <Pie
                data={dataArray}
                cx="50%"
                cy="50%"
                className="my-2"
                activeIndex={activeIndex}
                labelLine={false}
                label={renderCustomizedLabel}
                activeShape={renderActiveShape}
                outerRadius={80}
                fill="#8884d8"
                dataKey="value"
                onMouseEnter={onPieEnter}
            >
                {dataArray.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
            </Pie>
            <Tooltip />
            <Legend />
        </PieChart>
    );
}

export default YesNoPieChart;
